import { ReactElement } from 'react'
import SeriesV3 from '../series'

export default (): ReactElement => <SeriesV3 />
